import React from 'react'

import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 48
}

/**
 * Stateless function representing a charger type icon (08) - Pantograph.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <EvChargerType08Icon width={12} />
 */
const EvChargerType08Icon = props => (
    <SvgIcon {...props}>
        <path
            d={`m42,33.31v3.38c0,.72-.59,1.31-1.31,1.31H7.31c-.72,0-1.31-.59-1.31-1.31v-3.38c0-.72.59-1.31,
                1.31-1.31h10.15c.1-.28.25-.54.47-.76l7.91-7.91-11.07-11.07c-.08-.08-.15-.17-.21-.26h-.34l-6.81,
                6.81-2.83-2.83,7.98-7.98h.01s0,0,0,0h22.84s7.98,7.98,7.98,7.98l-2.83,2.83-6.81-6.81h-13.59l9.91,
                9.91c.78.78.78,2.05,0,2.83h0s0,0-.01.01c0,0,0,0-.01.01l-7.24,7.24h17.86c.72,0,1.31.59,1.31,1.31Z`}
        />
    </SvgIcon>
)

EvChargerType08Icon.defaultProps = defaultProps

export { EvChargerType08Icon }
